// extracted by mini-css-extract-plugin
module.exports = {"dataSelector":"DataSelector_dataSelector__AKgzh","active":"DataSelector_active__2x_Oa","selected":"DataSelector_selected__3KhWQ"};